import { useTheme } from "@mui/material/styles"
import { BaseEdge, getSmoothStepPath } from "reactflow"

export default function CustomStepEdge({
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  ...props
}) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 0,
  })
  const theme = useTheme()
  return (
    <BaseEdge
      path={edgePath}
      style={{ ...style, stroke: theme.palette.colors.gray300 }}
      {...props}
    />
  )
}
